module.exports = __webpack_public_path__ + "images/emoji/golf.18ef3c4557222220bfe2.png";